/**
 * @file 内容组件
 */
import { useEntityList } from './hooks';

import { EntityList } from './entities';
import { Ranks } from './ranks';
import { Hero } from './hero';
import Analysis from './analysis';
import { FAQ } from './faq';

export const Content = () => {
  const { entityLoading, entityList } = useEntityList();

  return (
    <div className="md:min-w-[1200px] max-w-full mx-auto">
      {/* Hero Section */}
      <Hero />
      <EntityList loading={entityLoading} data={entityList} />
      <div className="max-[768px]:hidden">
        <Analysis entityList={entityList} entityLoading={entityLoading} />
      </div>
      <Ranks />
      <FAQ />
    </div>
  );
};
